/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import StepeperProcesos from "../stepperProcesos";
export default function PreOperatorio() {
  const steps = [
    {
      numero: "1",
      titulo: "CITAS",
      pasos: ["Agendar cita para Activación y Programación en Aurea Lab."],
      roles: [93, 98],
    },
    {
      numero: "2",
      titulo: "INFORMES",
      pasos: ["Subir informes quirúrgico:", "- Activación", "- Programación"],
      roles: [93],
    },
    {
      numero: "3",
      titulo: "TAV",
      pasos: [
        "Se realizará 1 a la semana de forma presencial u online. Se subirán los informes de manera trimestral.",
      ],
      roles: [99],
    },
    {
      numero: "4",
      titulo: "CITAS AUDIOLOGIA",
      pasos: [
        "Agendar citas y subir informes correspondientes:",
        "- Programaciones",
        "- Audiometrías",
        "- Ganancias Funcionales",
      ],
      roles: [93],
    },
  ];

  return <StepeperProcesos steps={steps} />;
}
